import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";

export function usePricingPlanRows(
  uploadId: number | undefined,
  options: { status?: string; page?: number; limit?: number; refetchInterval?: number | false } = {},
) {
  const { status, page = 1, limit = 50, refetchInterval = false } = options;
  return useQuery({
    queryKey: [{ entity: "pricing_plan_upload_rows", id: uploadId, status, page, limit }],
    queryFn: async () =>
      await apiClient.listPricingPlanUploadRows({
        params: { id: uploadId! },
        queries: { status, page, limit },
      }),
    enabled: !!uploadId,
    refetchInterval,
  });
}
